module.exports = __webpack_public_path__ + "img/1.d83519b8.svg";